<pt-breadcrumbs current="Partners" class="bg-white" />
<div class="border-b border-solid border-slate-300"></div>

<div class="wrapper">
  <div class="flex flex-col gap-4">
    <div class="flex gap-4">
      <pt-search-field class="flex-1">
        <input matInput placeholder="Search" [formControl]="search" />
      </pt-search-field>
      <button mat-raised-button color="primary" (click)="addPartner()">
        Create Partner
      </button>
    </div>

    <mat-nav-list>
      @if (searchFilter.results$ | async; as partners) {
        @for (partner of partners; track partner.ref.path) {
          <a mat-list-item [routerLink]="['./', partner.ref.id]">
            <span matListItemTitle>{{ partner.name }}</span>
            <span matListItemSubtitle class="mat-caption"
              >Regions: {{ partner | map: getRegions }}</span
            >
            <div matListItemMeta>
              <div class="flex justify-end gap-2 align-middle">
                <pr-partner-status [status]="partner.status" />
                <mat-icon>chevron_right</mat-icon>
              </div>
            </div>
          </a>
        }
      }
    </mat-nav-list>
  </div>
</div>
